import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { useLenis } from "./hooks/useLenis";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Category from "./pages/Category";
import Product from "./pages/Product";
import Brands from "./pages/Brands";
import Tools from "./pages/Tools";
import Search from "./pages/Search";
import Fitment from "./pages/Fitment";
import Checkout from "./pages/Checkout";
import Account from "./pages/Account";
import Policies from "./pages/Policies";
import AuthCallback from "./pages/AuthCallback";
import { Login, Register } from "./pages/Auth";
import Admin from "./pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth redirect (session_id in URL fragment) before anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <CartDrawer />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:category" element={<Category />} />
          <Route path="/product/:slug" element={<Product />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/search" element={<Search />} />
          <Route path="/fitment" element={<Fitment />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/account" element={<Account />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  useLenis();
  return (
    <div className="App">
      <div className="grain" />
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRouter />
            <Toaster position="top-center" theme="dark" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
